import React from 'react';
import {Link} from 'react-router-dom';
import getText from 'AppUtils/language';

import FormField from '../../../../../../common/form-field/FormFieldComponent';
import Button from '../../../../../../common/button/ButtonComponent';

import './Prompt.scss';

const PromptComponent = (props) => {
	return (
		<div className="prompt-component">
			<form onSubmit={(e) => props.handleSubmit(e)}>
				<div className="inputs-wrapper">
					<div className="shadow-wrapper">
						<FormField
							{...props.formData.phone}
							handleChange={(element) => props.handleInputChange(element)}
							validationMessage={props.formData.phone.validationMessage}
							prefix={props.prefix}
							maxLength={props.msisdn.maxLength ? props.msisdn.maxLength : false}
							rtl={props.rtl}
						/>
					</div>
				</div>

				<button type="submit">
					<Button
						fullWidth={true}
						boxShadow={true}
					>
						{getText('register[button_register]')}
					</Button>
				</button>
			</form>
			<div className="btn-actions">
				<Link to="/">
					<Button
						outline={true}
					>
						{getText('register[button_cancel]')}
					</Button>
				</Link>
			</div>
		</div>
	);
};

export default PromptComponent;
